import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/bcn-best-places-to-work-2025.png")